import React, { createContext, ReactElement, ReactNode, useContext } from 'react';
import { Steps } from '../../wizard/Steps';

export interface StepScopeState {
    stepNumber: Steps;
}

export interface StepScopeProviderProps {
  value: StepScopeState;
  children?: ReactNode;
}

const StepScopeProviderContext = createContext<StepScopeState>({} as StepScopeState);

export function useStepScopeProvider(): StepScopeState {
  const context = useContext(StepScopeProviderContext);

  return context;
}

export function StepScopeProvider({ value, children }: StepScopeProviderProps): ReactElement {
  return <StepScopeProviderContext.Provider value={value}>{children}</StepScopeProviderContext.Provider>;
}
